/**
* @module broker
* Moduł umożliwiający komunikację pomiedzy modułami za pośrednictwem magistrali zdarzeń.
*/
app.service('broker', () => {
	const $broker = $({});

	const getHandler = elem =>
		elem ? elem : $broker;

	const trigger = (event, data, elem) => {
		const $handler = getHandler(elem);
		return $handler.trigger(event, data);
	};

	const on = (event, callback, scope = $broker) =>
		$broker.on(event, $.proxy(callback, scope));

	const off = event =>
		$broker.off(event);

	return {
		trigger, 
		on,
		off
	};
});


